import { useEffect, useState } from "react";
import { applyAllowedFilters } from "./applyAllowedFilters";

import Filter from "./filter";
import moment from "moment";
import { isEmpty } from "lodash";
// Task 24767 - the Overdue tabs share their definition with the pill on the
// rows, so the list and the badges inside it cannot disagree.
import { isOverdue } from "../Common/OverdueByPill";
import { isWrittenOff } from "../Common/BadDebtPill";

export default function LocalDataSearch({
  ReceivedDataAPI,
  recurringJobListDataAPI,
  setSearchInActionShowLoading,
  activeSearchTab,
  allowedSearchFilters,
  searchQuery,
  setSearchFilteredResults,
  Page,
  showFilter,
  setShowFilter,
  toggleShowFilter,
  allowedFiltersInit,
  allowedFilters,
  setAllowedFilters,
  allBankTransactionUnAllocatedListAPI, // for AllBankTransactionsListPage Unallocated Tab
  AssignedOnlyBankTransactions, // for AllBankTransactionsListPage Assigned Tab
  alternativeData, // Alternative API data from another component / page
  component, // Component / Page name
  singleJobInvoiceListDataAPI,
  readyToInvoiceJobsListDataAPI,
  contractItemsActiveListAPI,
  contractItemsCancelledListAPI,
  CustomOptionsData,
}) {
  const LS_Staff_ID = JSON.parse(localStorage.getItem("authUser"))
    ?.get_staff_data?.Staff_Id;

  // SEARCH FUNCTIONALITY STARTS HERE
  useEffect(() => {
    setSearchInActionShowLoading(true);
    let filteredDataList;
    filteredDataList = ReceivedDataAPI; // default data

    if (Page === "StaffToStaffSkillSet") {
      console.log("ReceivedDataAPI", ReceivedDataAPI);
      console.log("called");
      if (activeSearchTab === "1") {
        console.log("active tab 1");
        //Active means if expiry date is more then today or null or "" or date not valid
        filteredDataList = filteredDataList?.filter((item) => {
          if (
            item?.ValidToDateTime === null ||
            item?.ValidToDateTime === "" ||
            !moment(item?.ValidToDateTime, "YYYY-MM-DD", true).isValid() ||
            moment(item?.ValidToDateTime).isAfter(new Date())
          ) {
            return item;
          }
        });
      }
      if (activeSearchTab === "2") {
        console.log("active tab 2");
        //Expired means if expiry date is less then today and date must be valid
        filteredDataList = filteredDataList?.filter((item) => {
          if (
            moment(item?.ValidToDateTime, "YYYY-MM-DD", true).isValid() &&
            moment(item?.ValidToDateTime).isBefore(new Date())
          ) {
            return item;
          }
        });
      }

      if (activeSearchTab === "3") {
        console.log("active tab 3");
        //all
        filteredDataList = filteredDataList?.filter((item) => item);
      }
    }
    // StaffSingleLeaveRequestPage
    if (Page === "StaffSingleLeaveRequestPage") {
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((item) => item);
      }
      if (activeSearchTab === "pending") {
        filteredDataList = filteredDataList?.filter(
          (item) => item?.StaffLeaveStatus_Id === "1"
        );
      }
      if (activeSearchTab === "approved") {
        filteredDataList = filteredDataList?.filter(
          (item) => item?.StaffLeaveStatus_Id === "2"
        );
      }
      if (activeSearchTab === "declined") {
        filteredDataList = filteredDataList?.filter(
          (item) => item?.StaffLeaveStatus_Id === "3"
        );
      }
    }

    // Page Spesific Search and Filter
    // if Page is AllBankTransactionsListALLPage
    if (Page === "AllBankTransactionsListPage") {
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((item) => item);
      }
      if (activeSearchTab === "pending") {
        filteredDataList = allBankTransactionUnAllocatedListAPI;
      }
      if (activeSearchTab === "assigned") {
        filteredDataList = AssignedOnlyBankTransactions;
      }
      filteredDataList = filteredDataList?.sort((a, b) => {
        return (
          new Date(a?.TransactionDateTime) - new Date(b?.TransactionDateTime)
        );
      });
    }
    // if Page is BankListPage
    if (Page === "BankListPage") {
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((item) => item);
      }
      if (activeSearchTab === "active") {
        filteredDataList = filteredDataList?.filter(
          (item) => item?.BankAccountStatus_FlagActive === "1"
        );
      }
    }
    // Change #100069 - the P&L "Purchases" drill-down. A category row on
    // /profit-and-loss opens /purchase-item-list with that category and the
    // statement's period. It used to compare the end date to midnight (so the
    // last day of the period dropped out), compare ids strictly (a number vs a
    // string matched nothing) and could not match the "Uncategorised" row.
    // It ran twice, once per page name; now once, here.
    if (
      (Page === "PurchaseItemListPage" || Page === "PurchaseListPage") &&
      !isEmpty(CustomOptionsData) &&
      CustomOptionsData?.type === "purchase-items"
    ) {
      const wantCategory = CustomOptionsData?.item?.PurchaseItemCategory_Id;
      const start = CustomOptionsData?.dateRange?.startDate;
      const end = CustomOptionsData?.dateRange?.endDate;
      filteredDataList = filteredDataList?.filter((item) => {
        // An "Uncategorised" row carries no category id: match items with none.
        const sameCategory =
          wantCategory === null || wantCategory === undefined || wantCategory === ""
            ? !item?.PurchaseItemCategory_Id
            : String(item?.PurchaseItemCategory_Id) === String(wantCategory);
        const when = moment(item?.Purchase_PurchaseDateTime);
        return (
          sameCategory &&
          (!start || when.isSameOrAfter(start, "day")) &&
          (!end || when.isSameOrBefore(end, "day"))
        );
      });
    }

    // if Page is PurchaseListPage
    if (Page === "PurchaseListPage") {

      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((item) => item);
      }
      if (activeSearchTab === "unpaid") {
        filteredDataList = filteredDataList?.filter(
          (item) => Number(item?.AmountUnCleared) > 0
        );
      }
      if (activeSearchTab === "paid") {
        filteredDataList = filteredDataList?.filter(
          (item) => Number(item?.AmountUnCleared) === 0
        );
      }
    } // if Page is PurchaseListPage
    // if Page is PurchaseOrderListPage
    if (Page === "PurchaseOrderListPage") {
      const isComplete = (item) =>
        item?.PurchaseOrderStatus_Name === "Complete";
      if (activeSearchTab === "completed") {
        // Completed tab: only the purchase orders that have been cleared down
        filteredDataList = filteredDataList?.filter((item) => isComplete(item));
      } else {
        // Working tabs never show completed (cleared down) purchase orders
        filteredDataList = filteredDataList?.filter((item) => !isComplete(item));
        if (activeSearchTab === "unpaid") {
          filteredDataList = filteredDataList?.filter(
            (item) => Number(item?.AmountUnCleared) > 0
          );
        }
        if (activeSearchTab === "paid") {
          filteredDataList = filteredDataList?.filter(
            (item) => Number(item?.AmountUnCleared) === 0
          );
        }
        // "all" => every non-complete purchase order, no further filter
      }
    } // if Page is PurchaseOrderListPage
    if (Page === "PurchaseDraftListPage") {
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((item) => item);
      }
      if (activeSearchTab === "unpaid") {
        filteredDataList = filteredDataList?.filter(
          (item) => Number(item?.AmountUnCleared) > 0
        );
      }
      if (activeSearchTab === "paid") {
        filteredDataList = filteredDataList?.filter(
          (item) => Number(item?.AmountUnCleared) === 0
        );
      }
    } // if Page is PurchaseDraftListPage
    if (Page === "PurchaseItemListPage") {
      //sort it all by Purchase_DueDateTime new to old
      filteredDataList = filteredDataList?.sort((a, b) => {
        return (
          new Date(a?.Purchase_PurchaseDateTime)?.getTime() -
          new Date(b?.Purchase_PurchaseDateTime)?.getTime()
        );
      });
      // Change #100069 - the P&L category/period filter is applied once, above.

      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((item) => item);
      }
      if (activeSearchTab === "unpaid") {
        filteredDataList = filteredDataList?.filter(
          (item) => Number(item?.AmountUnCleared) > 0
        );
      }
      if (activeSearchTab === "paid") {
        filteredDataList = filteredDataList?.filter(
          (item) => Number(item?.AmountUnCleared) === 0
        );
      }
    }

    if (Page === "SingleSupplierPurchaseListPage") {
      if (activeSearchTab === "unpaid") {
        filteredDataList = filteredDataList?.filter(
          (item) => item?.AmountUnCleared !== "0.00"
        );
      }
      if (activeSearchTab === "paid") {
        filteredDataList = filteredDataList?.filter(
          (item) => item?.AmountUnCleared === "0.00"
        );
      }
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((item) => item);
      }
    }

    // If Page is JobListPage
    if (Page === "JobListPage") {
      if (activeSearchTab === "recurring") {
        filteredDataList = recurringJobListDataAPI;
      }

      if (activeSearchTab === "open") {
        filteredDataList = filteredDataList?.filter(
          (invoice) => invoice.JobStatus_FlagActive === "1"
        );
      }
      if (activeSearchTab === "myOpen") {
        filteredDataList = filteredDataList?.filter(
          (invoice) =>
            invoice.JobStatus_FlagActive === "1" &&
            invoice.Staff_Id === LS_Staff_ID
        );
      }
      if (activeSearchTab === "myAssigned") {
        filteredDataList = filteredDataList?.filter(
          (invoice) => invoice.Staff_Id === LS_Staff_ID
        );
      }
      if (activeSearchTab === "unassigned") {
        filteredDataList = filteredDataList?.filter(
          (item) =>
            item.Staff_Id === null ||
            item.Staff_Id === 0 ||
            item.Staff_Id === undefined
        );
      }
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((item) => item);
      }
    } // If Page is Uninvoiced JobListPage
    if (Page === "UninvoicedJobListPage") {
      console.log("page === UninvoicedJobListPage", activeSearchTab);
    }
    // If Page is EventPreorderWeekly
    if (Page === "EventPreorderWeekly") {
      //     sort by event date time using memo
      filteredDataList = filteredDataList?.sort((a, b) => {
        return new Date(a?.EventDateTime) - new Date(b?.EventDateTime);
      });
    }
    //EventPreOrderGroupList
    if (Page === "EventPreOrderGroupList") {
      //     sort by event date time using memo
      filteredDataList = filteredDataList?.sort((a, b) => {
        return new Date(a?.EventDateTime) - new Date(b?.EventDateTime);
      });
      //open and all tabs
      if (activeSearchTab === "open") {
        filteredDataList = filteredDataList?.filter(
          (item) => item.EventStatus_FlagActive === "1"
        );
      }
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((item) => item);
      }
    }
    // If Page is TaskListPage
    if (Page === "TaskListPage") {
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((item) => item);
      }
      // Default Open
      if (activeSearchTab === "open") {
        // where expiry date > Today & Redeem date is null
        filteredDataList = filteredDataList?.filter(
          (item) => item.TaskStatus_FlagActive === "1"
        );
      }
    }
    // If Page is InvoiceListPage
    if (Page === "InvoiceListPage") {
      if (activeSearchTab === "auto-generated") {
        filteredDataList = filteredDataList?.filter(
          (invoice) =>
            invoice.InvoiceStatus_FlagActive === "1" &&
            invoice.FlagAutoGenerated === "1"
        );
      }
      if (activeSearchTab === "open") {
        filteredDataList = filteredDataList?.filter(
          (invoice) => invoice?.InvoiceStatus_FlagActive === "1"
        );
      }
      // Task 24767 - past its due date and still owing. Uses the same
      // isOverdue the pill uses, so the tab and the badges on its rows can
      // never disagree about what overdue means.
      if (activeSearchTab === "overdue") {
        filteredDataList = filteredDataList?.filter((invoice) =>
          isOverdue(
            invoice?.DueDateTime,
            // Change #100090 - a written-off bad debt is not being chased.
            Number(invoice?.AmountUnCleared || 0) <= 0 || isWrittenOff(invoice)
          )
        );
      }
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((invoice) => invoice);
      }
    }
    if (Page === "ProformaInvoiceListPage") {
      if (activeSearchTab === "auto-generated") {
        filteredDataList = filteredDataList?.filter(
          (invoice) =>
            invoice.ProformaInvoiceStatus_FlagActive === "1" &&
            invoice.FlagAutoGenerated === "1"
        );
      }
      if (activeSearchTab === "open") {
        filteredDataList = filteredDataList?.filter(
          (invoice) => invoice?.ProformaInvoiceStatus_FlagActive === "1"
        );
      }
      // Task 24767 - same tab on the proforma side. Settled here also means
      // converted to an invoice: that proforma's job is done, and chasing it
      // would be chasing the same money twice.
      if (activeSearchTab === "overdue") {
        filteredDataList = filteredDataList?.filter((invoice) =>
          isOverdue(
            invoice?.DueDateTime,
            Number(invoice?.AmountUnCleared || 0) <= 0 ||
              Number(invoice?.FlagConvertedToInvoice || 0) === 1 ||
              Boolean(invoice?.Invoice_Id)
          )
        );
      }
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((invoice) => invoice);
      }
    }
    // if Page is TimeEntriesListPage
    if (Page === "TimeEntriesListPage") {
      if (component === "Time Entries") {
        filteredDataList = alternativeData;
      }
      if (activeSearchTab === "today") {
        filteredDataList = filteredDataList?.filter((timeEntries) =>
          moment(timeEntries?.TimeEntryStartDateTime).isSame(new Date(), "day")
        );
      }
      // Yesterday
      if (activeSearchTab === "yesterday") {
        filteredDataList = filteredDataList?.filter((timeEntries) =>
          moment(timeEntries?.TimeEntryStartDateTime).isSame(
            moment().subtract(1, "days"),
            "day"
          )
        );
      }
      // open
      if (activeSearchTab === "open") {
        filteredDataList = filteredDataList?.filter(
          (timeEntries) => timeEntries?.TimeEntryEndDateTime === null
        );
      }
      // mytime
      if (activeSearchTab === "mytime") {
        filteredDataList = filteredDataList?.filter(
          (timeEntries) => timeEntries?.Staff_Id === LS_Staff_ID
        );
      }
      // Billable
      if (activeSearchTab === "billable") {
        filteredDataList = filteredDataList?.filter(
          (timeEntries) => timeEntries?.BillableType === "1"
        );
      }
      // Unbillable
      if (activeSearchTab === "unbillable") {
        filteredDataList = filteredDataList?.filter(
          (timeEntries) => timeEntries?.BillableType === "2"
        );
      }

      //All
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter(
          (timeEntries) => timeEntries
        );
      }
    }
    // if Page is SingleCustomerJobListPage
    if (Page === "SingleCustomerJobListPage") {
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((job) => job);
        console.log("filteredDataList", filteredDataList);
      }
      if (activeSearchTab === "open") {
        filteredDataList = filteredDataList?.filter(
          (job) => job.JobStatus_FlagActive === "1"
        );
        console.log("filteredDataList", filteredDataList);
      }

      if (activeSearchTab === "uninvoiced") {
        filteredDataList = filteredDataList?.filter(
          (job) =>
            (job?.FlagInvoiced === null || job?.FlagInvoiced === "0") &&
            (job?.JobStatus_FlagActive === "0" ||
              job?.JobStatus_FlagActive === null)
        );
        console.log("filteredDataList", filteredDataList);
      }
    }
    // if Page is SingleCustomerInvoiceListPage
    if (Page === "SingleCustomerInvoiceListPage") {
      if (activeSearchTab === "unpaid") {
        filteredDataList = filteredDataList?.filter(
          (invoice) => invoice?.AmountUnCleared !== "0.00"
        );
      }
      if (activeSearchTab === "paid") {
        filteredDataList = filteredDataList?.filter(
          (invoice) => invoice?.AmountUnCleared === "0.00"
        );
      }
      // Task 24767 - the customer's own Invoices tab gets the same tab, so
      // "who is late" reads the same whether you come at it from one customer
      // or from the whole list.
      if (activeSearchTab === "overdue") {
        filteredDataList = filteredDataList?.filter((invoice) =>
          isOverdue(
            invoice?.DueDateTime,
            // Change #100090 - a written-off bad debt is not being chased.
            Number(invoice?.AmountUnCleared || 0) <= 0 || isWrittenOff(invoice)
          )
        );
      }
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((invoice) => invoice);
      }
    }
    if (Page === "SingleJobInvoiceList") {
      filteredDataList = singleJobInvoiceListDataAPI;
      if (activeSearchTab === "unpaid") {
        filteredDataList = filteredDataList?.filter(
          (invoice) => invoice?.AmountUnCleared !== "0.00"
        );
      }
      if (activeSearchTab === "paid") {
        filteredDataList = filteredDataList?.filter(
          (invoice) => invoice?.AmountUnCleared === "0.00"
        );
      }
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((invoice) => invoice);
      }
    }
    //if Page is SingleCustomerTaskListPage
    if (Page === "SingleCustomerTaskListPage") {
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((item) => item);
      }
      // Default Open
      if (activeSearchTab === "open") {
        // where expiry date > Today & Redeem date is null
        filteredDataList = filteredDataList?.filter(
          (item) => item.TaskStatus_FlagActive === "1"
        );
      }
    }
    // if Page is ContractListPage
    if (Page === "ContractListPage") {
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((invoice) => invoice);
      }
      if (activeSearchTab === "active") {
        filteredDataList = filteredDataList?.filter(
          (invoice) => invoice?.ContractStatus_FlagActive === "1"
        );
      }

      if (activeSearchTab === "canceled") {
        filteredDataList = filteredDataList?.filter(
          (invoice) => invoice?.ContractStatus_FlagCancelled === "1"
        );
      }
    }
    // if Page TransactionsListPage
    if (Page === "TransactionsListPage") {
      filteredDataList = filteredDataList?.sort((a, b) => {
        // news date first
        return (
          new Date(a.TransactionDateTime)?.getTime() -
          new Date(b.TransactionDateTime)?.getTime()
        );
      });
    }
    // if Page is ContractItemsListPage
    if (Page === "ContractItemsListPage") {
      if (activeSearchTab === "active") {
        filteredDataList = contractItemsActiveListAPI;
      }
      if (activeSearchTab === "activeTimeTracked") {
        filteredDataList = filteredDataList?.filter((item) => {
          //Active" is where API field EndDateTime is NULL OR EndDateTime > today
          if (item.EndDateTime == null && item.AllowedJobAllocation === "1") {
            return item;
          }
          if (
            item.EndDateTime > moment().format("YYYY-MM-DD") &&
            item.AllowedJobAllocation === "1"
          ) {
            return item;
          }
        });
      }
      if (activeSearchTab === "timeTrackedPDF") {
        filteredDataList = contractItemsActiveListAPI;
        filteredDataList = filteredDataList?.filter(
          (item) => item?.TimeTracked === "1"
        );
        console.log("TimeTracked filteredDataList", filteredDataList);
      }
      if (activeSearchTab === "canceled") {
        filteredDataList = contractItemsCancelledListAPI;
      }
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((item) => item);
      }
    }

    // if Page is SupplierBalanceListPage
    if (Page === "SupplierBalanceListPage") {
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((item) => item);
      }
      if (activeSearchTab === "overdue") {
        filteredDataList = filteredDataList?.filter(
          (item) =>
            item?.BalanceTotalAmount > 0 && item?.BalanceOverdueTotalAmount > 0
        );
      }
      if (activeSearchTab === "balance") {
        filteredDataList = filteredDataList?.filter(
          (item) => item?.BalanceTotalAmount > 0
        );
      }
    } // if Page is CustomerListPage
    if (Page === "CustomerListPage") {
      if (activeSearchTab === "all") {
        filteredDataList = filteredDataList?.filter((item) => item);
      }
      if (activeSearchTab === "unassignedType") {
        filteredDataList = filteredDataList?.filter(
          (item) => item?.CustomerType_Id === null
        );
      }
    }
    // Change #100438 - panel filters, shared with pages that filter their own list.
    filteredDataList = applyAllowedFilters(filteredDataList, allowedFilters);

    filteredDataList = filteredDataList?.filter((item) => {
      return allowedSearchFilters?.some((key) => {
        return (
          item[key] &&
          item[key]
            ?.toString()
            ?.toLowerCase()
            ?.includes(searchQuery?.toLowerCase())
        );
      });
    });

    setSearchFilteredResults(filteredDataList);
    setSearchInActionShowLoading(false);
  }, [
    searchQuery,
    activeSearchTab,
    ReceivedDataAPI,
    recurringJobListDataAPI,
    allowedFilters,
    CustomOptionsData,
    readyToInvoiceJobsListDataAPI,
    allBankTransactionUnAllocatedListAPI,
  ]);

  return (
    <>
      {showFilter && (
        <Filter
          showFilter={showFilter}
          setShowFilter={setShowFilter}
          toggleShowFilter={toggleShowFilter}
          allowedFiltersInit={allowedFiltersInit}
          allowedFilters={allowedFilters}
          setAllowedFilters={setAllowedFilters}
        />
      )}
    </>
  );
}
